var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRenters(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.46875 2.75C5.46875 2.18046 5.93046 1.71875 6.5 1.71875H23.5C24.0695 1.71875 24.5312 2.18046 24.5312 2.75V27.5C24.5312 27.9315 24.1815 28.2812 23.75 28.2812H6.25C5.81853 28.2812 5.46875 27.9315 5.46875 27.5V2.75ZM7.03125 3.28125V26.7188H22.9688V3.28125H7.03125Z",
    fill: "#0173C6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7188 20C11.7188 19.5685 12.0685 19.2188 12.5 19.2188H17.5C17.9315 19.2188 18.2812 19.5685 18.2812 20V27.5C18.2812 27.9315 17.9315 28.2812 17.5 28.2812H12.5C12.0685 28.2812 11.7188 27.9315 11.7188 27.5V20ZM13.2812 20.7812V26.7187H16.7188V20.7812H13.2812Z",
    fill: "#0173C6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.59375 7.5C8.59375 7.06853 8.94353 6.71875 9.375 6.71875H20.625C21.0565 6.71875 21.4062 7.06853 21.4062 7.5C21.4062 7.93147 21.0565 8.28125 20.625 8.28125H9.375C8.94353 8.28125 8.59375 7.93147 8.59375 7.5ZM8.59375 11.25C8.59375 10.8185 8.94353 10.4688 9.375 10.4688H20.625C21.0565 10.4688 21.4062 10.8185 21.4062 11.25C21.4062 11.6815 21.0565 12.0313 20.625 12.0313H9.375C8.94353 12.0313 8.59375 11.6815 8.59375 11.25ZM8.59375 15C8.59375 14.5685 8.94353 14.2188 9.375 14.2188H20.625C21.0565 14.2188 21.4062 14.5685 21.4062 15C21.4062 15.4315 21.0565 15.7813 20.625 15.7813H9.375C8.94353 15.7813 8.59375 15.4315 8.59375 15Z",
    fill: "#0173C6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.21875 27.5C4.21875 27.0685 4.56853 26.7187 5 26.7187L25 26.7187C25.4315 26.7187 25.7813 27.0685 25.7813 27.5C25.7813 27.9315 25.4315 28.2812 25 28.2812L5 28.2812C4.56853 28.2812 4.21875 27.9315 4.21875 27.5Z",
    fill: "#0173C6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRenters);
export default __webpack_public_path__ + "static/media/Renters.56a9b1d0.svg";
export { ForwardRef as ReactComponent };